import { v4 as uuid } from "uuid";

export const isUnsavedFinishedPiece = (id: any) =>
  String(id || "").includes("-");

export const applyFinishedPiecesChange = ({
  list,
  newData,
  process,
  orderId,
}: {
  list: any[];
  newData: any;
  process: string;
  orderId: any;
}) => {
  const action = newData.action || "create";
  const item = {
    ...newData,
    process,
    order: orderId,
  };

  let nextList = list;
  if (action === "create") {
    nextList = [...list, { ...item, id: item.id || uuid() }];
  } else if (action === "update") {
    nextList = list.some((row) => String(row.id) === String(newData.id))
      ? list.map((row) =>
          String(row.id) === String(newData.id) ? { ...row, ...item } : row
        )
      : list;
  } else if (action === "delete") {
    nextList = list.filter((row) => String(row.id) !== String(newData.id));
  }

  return {
    list: nextList,
    qty: newData.total_qty,
    realWeight: newData.total_real_weight,
  };
};
